<template>
  <section class="live-controls btn-group btn-group-sm mr-1">
    <button
      class="btn btn-primary"
      @click.stop.prevent="stop">
      {{ stopMsg }}
    </button>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LiveControls',

  date () {
    return {
    }
  },

  computed: {
    ...mapGetters('room', [
      'isCast',
      'isWatch'
    ]),
    stopMsg () {
      if (this.isCast) {
        return '!!!방송종료'
      } else {
        return '시청종료'
      }
    }
  },

  methods: {
    stop () {
      this.$store.commit('room/setRoomType', null)
    }
  }
}
</script>

<style scoped>
</style>
